import React, { useState } from 'react';

import { MCButton, Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { lang, remCss } from 'src/helpers';
import { getStripePromise } from 'src/helpers/stripe';
import mainModel from './model';
import { Elements, PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js';

const CheckoutForm = ({ hide, afterSave }) => {
  const stripe = useStripe();
  const elements = useElements();

  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }
    setLoading(true);
    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: 'https://example.com/setup/complete'
      },
      redirect: 'if_required'
    });
    setLoading(false);

    if (error) {
      setErrorMessage(error.message);
    } else {
      console.log('setupIntent', setupIntent);
      if (setupIntent.status === 'succeeded') {
        console.log('setupIntent stripeList 1');
        mainModel.stripeList({
          cb: () => {
            console.log('setupIntent stripeList 2');
            mainModel.stripeActive({ id: setupIntent.payment_method });
          }
        });
        if (!afterSave) hide();
        else afterSave();
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      {errorMessage && <div>{errorMessage}</div>}
      <div className='mc-modal-footer mc-flex' style={{ marginTop: remCss(20), borderTop: 'none' }}>
        <div className={'mc-grow'} />
        <MCButton
          primary
          dark
          radius
          medium
          loading={loading}
          disabled={loading || !stripe}
          type={'submit'}
          onClick={() => {}}
        >
          {loading ? lang.t('Adding') + '...' : lang.t('Add card')}
        </MCButton>
      </div>
    </form>
  );
};

class StripeForm extends BaseComponent {
  constructor() {
    super();
    this.state = {
      options: {
        clientSecret: undefined
      },
      stripeStatus: 'idle',
      stripeLoadError: null
    };
  }

  componentDidMount() {
    this.unmounted = false;
    this.getModel().subscribe(this.subscription);
    // this.getModel().resetCreateCard();
    this.createSetupIntent();
    this.ensureStripeLoaded();
  }

  getModel = () => this.props.model || mainModel;

  getOptions = () => this.state.options;

  componentDidUpdate(prevProps, prevState) {
    const prevClientSecret = prevState.options?.clientSecret;
    const nextClientSecret = this.getOptions()?.clientSecret;

    if (prevClientSecret !== nextClientSecret) {
      this.ensureStripeLoaded();
    }
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.getModel().unsubscribe(this.subscription);
  }

  ensureStripeLoaded = async () => {
    const options = this.getOptions();

    if (!options?.clientSecret) {
      if (this.state.stripeStatus !== 'idle' || this.state.stripeLoadError) {
        this.setState({ stripeStatus: 'idle', stripeLoadError: null });
      }
      return;
    }

    this.setState({ stripeStatus: 'loading', stripeLoadError: null });
    const stripePromise = getStripePromise();
    this.stripePromise = stripePromise;

    try {
      await stripePromise;

      if (this.unmounted || this.stripePromise !== stripePromise) {
        return;
      }

      this.setState({ stripeStatus: 'ready', stripeLoadError: null });
    } catch (error) {
      if (this.unmounted || this.stripePromise !== stripePromise) {
        return;
      }

      this.setState({
        stripeStatus: 'error',
        stripeLoadError: error?.message || 'Failed to load payment form. Please try again.'
      });
    }
  };

  retryStripeLoad = () => {
    this.ensureStripeLoaded();
  };

  createSetupIntent = async () => {
    const req = {
      currency: 'ron'
    };
    const cb = (err, data, success) => {
      if (success) {
        console.log('data', data);
        this.setState({
          options: {
            clientSecret: data.clientSecret
          }
        });
      }
    };
    this.getModel().api('card/stripe-setup-intent', req, (err, data, success) => {
      cb && cb(err, data, success);
    });
  };

  create = (event) => {
    event.preventDefault();
    const { hide } = this.props;
    this.getModel().create((error, data, success) => {
      if (success) hide();
    });
  };

  render() {
    const { closeBtn, hide, afterSave, onlyContent = false } = this.props;
    const { stripeStatus, stripeLoadError } = this.state;
    const stripePromise = this.stripePromise;
    const content = (
      <>
        <div className='mc-modal-header'>
          <div className='mc-popup-title'>{lang.t('Add card')}</div>
          {closeBtn}
        </div>
        {this.state.options.clientSecret ? (
          stripeStatus === 'error' ? (
            <div>
              <div className={'mc-error mc-mt10'}>{stripeLoadError}</div>
              <div
                className='mc-modal-footer mc-flex'
                style={{ marginTop: remCss(20), borderTop: 'none' }}
              >
                <div className={'mc-grow'} />
                <MCButton primary dark radius medium type={'button'} onClick={this.retryStripeLoad}>
                  {lang.t('Retry')}
                </MCButton>
              </div>
            </div>
          ) : stripeStatus === 'ready' ? (
            <Elements stripe={stripePromise} options={this.state.options}>
              <CheckoutForm hide={hide} afterSave={afterSave} />
            </Elements>
          ) : (
            <div>
              <Spinner />
            </div>
          )
        ) : (
          <div>
            <Spinner />
          </div>
        )}
      </>
    );

    if (onlyContent) {
      return content;
    }
    return (
      <div className='mc-popup-contain' style={{ width: remCss(600), overflow: 'auto' }}>
        {content}
      </div>
    );
  }
}

export default StripeForm;
